<app-main-header></app-main-header>
<div class="content">
  <app-fpcs-table></app-fpcs-table>
</div>
